import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material';
import {RegionModel} from '../../models/region.model';
import {CountryModel} from '../../models/country.model';
import {FilterHeaderService} from '../../services/filter-header.service';

@Component({
  selector: 'app-chose-location',
  templateUrl: './chose-location.component.html',
  styleUrls: ['./chose-location.component.css']
})
export class ChoseLocationComponent implements OnInit {

  public regions = COUNTRY_DATA;
  public masterIntermediate = false;
  public masterChecked = false;

  constructor(private dialogRef: MatDialogRef<ChoseLocationComponent>,
              private filterService: FilterHeaderService) {
    this.reorderCountries();
  }

  ngOnInit() {
    const selectedEntries = this.filterService.selectedFilterEntries['Country_name'];

    this.uncheckAll();

    if (selectedEntries) {
      const selectedCountries = [];

      selectedEntries.forEach(selectedCountry => {
        this.regions.forEach(region => {
          region.countries.forEach(country => {
            if (country.name === selectedCountry) {
              selectedCountries.push({region: region, country: country});
            }
          });
        });
      });

      selectedCountries.forEach(entry => {
        this.onCountryCheckChange({checked: true}, entry['country'], entry['region']);
      });
    }
  }

  onRegionChecked($event, region: RegionModel) {
    region.checked = $event['checked'];
    region.countries.forEach(country => country.checked = $event['checked']);
    this.onAnyChange();
  }

  onCountryCheckChange($event, country: CountryModel, region: RegionModel) {
    country.checked = $event['checked'];

    if (this.isAllChecked(region)) {
      region.intermediate = false;
      region.checked = true;
    } else if (this.hasChecked(region)) {
      region.intermediate = true;
      region.checked = false;
    } else {
      region.intermediate = false;
      region.checked = false;
    }
    this.onAnyChange();
  }

  onCancel() {
    this.dialogRef.close(undefined);
  }

  onSave() {
    const countries = this.regions.map(region => region.countries.filter(country => country.checked));

    this.dialogRef.close([].concat.apply([], countries));
  }

  private hasChecked(region: RegionModel) {
    return region.countries.filter(country => country.checked).length > 0;
  }

  private isAllChecked(region: RegionModel) {
    return region.countries.filter(value => value.checked).length === region.countries.length;
  }

  private onAnyChange() {
    const countries: Array<CountryModel> = this.regions.flatMap(region => region.countries);
    const checkedCountries = countries.filter(country => country.checked);

    if (checkedCountries.length === countries.length) {
      this.masterIntermediate = false;
      this.masterChecked = true;
    } else if (checkedCountries.length > 0) {
      this.masterIntermediate = true;
    } else {
      this.masterChecked = false;
      this.masterIntermediate = false;
    }
  }

  private reorderCountries() {
    this.regions.forEach(region => {
      this.sortCountries(region);
    });
  }

  private sortCountries(region) {
    region.countries.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
  }

  private uncheckAll() {
    this.regions.forEach(region => {
      region.checked = false;
      region.intermediate = false;
      region.countries.forEach(country => {
        country.checked = false;
      });
    });
  }

  onSelectAllChange($event) {
    const countries: Array<CountryModel> = this.regions.flatMap(region => region.countries);
    const checked = $event['checked'];
    this.masterChecked = checked;

    countries.forEach(country => country.checked = checked);
    this.regions.forEach(region => {
      region.checked = checked;
      region.intermediate = false;
    });
  }
}

export const COUNTRY_DATA = [
  new RegionModel('European Union', [
    new CountryModel('Austria'),
    new CountryModel('Belgium'),
    new CountryModel('Bulgaria'),
    new CountryModel('Croatia'),
    new CountryModel('Cyprus'),
    new CountryModel('Czech Republic'),
    new CountryModel('Denmark'),
    new CountryModel('Estonia'),
    new CountryModel('Finland'),
    new CountryModel('France'),
    new CountryModel('Germany'),
    new CountryModel('Greece'),
    new CountryModel('Hungary'),
    new CountryModel('Ireland'),
    new CountryModel('Italy'),
    new CountryModel('Latvia'),
    new CountryModel('Lithuania'),
    new CountryModel('Luxembourg'),
    new CountryModel('Malta'),
    new CountryModel('Netherlands'),
    new CountryModel('Poland'),
    new CountryModel('Portugal'),
    new CountryModel('Romania'),
    new CountryModel('Slovakia'),
    new CountryModel('Slovenia'),
    new CountryModel('Spain'),
    new CountryModel('Sweden'),
  ]),
  new RegionModel('European Free Trade Area', [
    new CountryModel('Iceland'),
    new CountryModel('Norway'),
    new CountryModel('Switzerland'),
    new CountryModel('Liechtenstein'),
    new CountryModel('United Kingdom'),
  ]),
  new RegionModel('Other Europe', [
    new CountryModel('Albania'),
    new CountryModel('Belarus'),
    new CountryModel('Bosnia'),
    new CountryModel('North Macedonia'),
    new CountryModel('Moldova'),
    new CountryModel('Russia'),
    new CountryModel('Serbia'),
    new CountryModel('Turkey'),
    new CountryModel('Ukraine'),
  ]),
  new RegionModel('Americas', [
    new CountryModel('Argentina'),
    new CountryModel('Brazil'),
    new CountryModel('Canada'),
    new CountryModel('Chile'),
    new CountryModel('Colombia'),
    new CountryModel('Costa Rica'),
    new CountryModel('Ecuador'),
    new CountryModel('Guatemala'),
    new CountryModel('Mexico'),
    new CountryModel('Panama'),
    new CountryModel('Paraguay'),
    new CountryModel('Peru'),
    new CountryModel('Puerto Rico'),
    new CountryModel('United States'),
    new CountryModel('Uruguay'),
    new CountryModel('Venezuela'),
  ]),
  new RegionModel('Central Asia', [
    new CountryModel('Georgia'),
    new CountryModel('Kazakhstan'),
    new CountryModel('Turkmenistan'),
  ]),
  new RegionModel('Middle East', [
    new CountryModel('Bahrain'),
    new CountryModel('Iran'),
    new CountryModel('Iraq'),
    new CountryModel('Israel'),
    new CountryModel('Jordan'),
    new CountryModel('Kuwait'),
    new CountryModel('Lebanon'),
    new CountryModel('Omen'),
    new CountryModel('Qatar'),
    new CountryModel('Saudi Arabia'),
    new CountryModel('Syria'),
    new CountryModel('U. A. Emirates'),
    new CountryModel('Yemen'),
  ]),
  new RegionModel('Africa', [
    new CountryModel('Algeria'),
    new CountryModel('Egypt'),
    new CountryModel('Libya'),
    new CountryModel('Morocco'),
    new CountryModel('South Africa'),
    new CountryModel('Sudan'),
    new CountryModel('Tunisia'),
  ]),
  new RegionModel('Asia-Pacific', [
    new CountryModel('Australia'),
    new CountryModel('China'),
    new CountryModel('Hong Kong'),
    new CountryModel('India'),
    new CountryModel('Japan'),
    new CountryModel('Malaysia'),
    new CountryModel('New Zealand'),
    new CountryModel('Singapore'),
    new CountryModel('South Korea'),
    new CountryModel('Taiwan'),
    new CountryModel('Thailand'),
    new CountryModel('Vietnam'),
  ])
];

